export type ChosenCategoryType = {
  label: string;
  key: string;
  values: string[];
};

export type EventParamType = Record<string, string | string[]>;

export enum DataAvailability {
  No = 'No',
  Full = 'Full',
  Partial = 'Partial',
}

import { useAnalytics } from '@ecosystem/newron-client-lib';
import { EventName, EventParams, PropositionSection, TrackingMeta } from '../types';

export interface InternalEventParams extends EventParams {
  section: PropositionSection;
  subsection: string;
  pageName: string;
  locationId: string[];
  itemGroup: string[];
  periodicity: string;
  cells: string[];
  numberOfCells: string;
  cellAggregation: 'multicell' | 'singlecell';
  locationIdAggregation: 'many' | 'single';
  itemGroupAggregation: 'many' | 'single';
  proposition: string;
}

export interface AnalyticsEvent {
  eventName: string;
  params: InternalEventParams;
}

export type MappingFn = (eventName: EventName | string, meta?: TrackingMeta) => InternalEventParams;
export type PlatformTrackingFunction = ReturnType<typeof useAnalytics>['track'];
